"use strict";

exports.__esModule = true;
exports["default"] = exports.FAKE_COMPID = exports.EMPTY_GUID = void 0;

var _lodash = require("lodash");

var _mediaManager = require("@wix/media-manager");

var EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
exports.EMPTY_GUID = EMPTY_GUID;
var FAKE_COMPID = 'FAKE_COMPID';
exports.FAKE_COMPID = FAKE_COMPID;

var callCallbackWith = function callCallbackWith(value) {
  return function (cb) {
    return cb(value);
  };
};

var returnValue = function returnValue(value) {
  return function () {
    return value;
  };
};

var WixPolyfill = {
  getPublicAPI: returnValue({}),
  addEventListener: _lodash.noop,
  removeEventListener: _lodash.noop,
  currentMember: callCallbackWith(null),
  requestLogin: _lodash.noop,
  logOutCurrentMember: _lodash.noop,
  replaceSectionState: _lodash.noop,
  closeWindow: _lodash.noop,
  setHeight: _lodash.noop,
  resizeComponent: _lodash.noop,
  WindowOrigin: {},
  WindowPlacement: {},
  isApplicationInstalled: _lodash.noop,
  getAdsOnPage: _lodash.noop,
  getBoundingRectAndOffsets: _lodash.noop,
  getComponentInfo: callCallbackWith({
    compId: 'comp_id_1'
  }),
  getCurrentPageId: callCallbackWith('pageId'),
  getSitePages: returnValue([{
    id: '/'
  }]),
  getSiteMap: returnValue([{
    pageId: '/'
  }]),
  getSiteInfo: _lodash.noop,
  navigateToPage: _lodash.noop,
  scrollTo: _lodash.noop,
  setPageMetadata: _lodash.noop,
  Data: {
    Public: {
      get: _lodash.noop,
      set: _lodash.noop
    }
  },
  Dashboard: {
    getEditorUrl: callCallbackWith(null),
    openMediaDialog: function openMediaDialog(mediaType, multiSelection, onSuccess, onCancel) {
      if (onCancel === void 0) {
        onCancel = _lodash.noop;
      }

      return (0, _mediaManager.openMediaDialog)(mediaType, multiSelection, onSuccess, onCancel);
    }
  },
  Events: {
    PAGE_NAVIGATION_IN: 'PAGE_NAVIGATION_IN',
    PAGE_NAVIGATION_OUT: 'PAGE_NAVIGATION_OUT'
  },
  PubSub: {
    publish: _lodash.noop,
    subscribe: _lodash.noop,
    unsubscribe: _lodash.noop
  },
  openPopup: _lodash.noop,
  Utils: {
    getUid: returnValue(EMPTY_GUID),
    getSectionUrl: function getSectionUrl() {
      return window.location.protocol + "//" + window.location.host + "/";
    },
    getInstanceId: returnValue(EMPTY_GUID),
    getInstanceValue: returnValue(EMPTY_GUID),
    getViewMode: returnValue(''),
    navigateToSection: _lodash.noop,
    getCompId: returnValue(FAKE_COMPID),
    getOrigCompId: returnValue(FAKE_COMPID),
    Media: {
      getImageUrl: function getImageUrl(image) {
        return "https://static.wixstatic.com/media/" + image;
      }
    }
  },
  Performance: {
    applicationLoaded: _lodash.noop,
    applicationLoadingStep: _lodash.noop
  },
  Settings: {
    setHelpArticle: function setHelpArticle(articleId) {
      return (0, _lodash.invoke)(window, 'ModuleRegistry.invoke', 'businessManager.setHelpArticle', {
        articleId: "/" + articleId
      });
    },
    triggerSettingsUpdatedEvent: _lodash.noop,
    openMediaDialog: function openMediaDialog(mediaType, multiSelection, onSuccess, onCancel) {
      if (onCancel === void 0) {
        onCancel = _lodash.noop;
      }

      return (0, _mediaManager.openMediaDialog)(mediaType, multiSelection, onSuccess, onCancel);
    },
    MediaType: _mediaManager.MEDIA_TYPES
  },
  Styles: {
    getSiteTextPresets: returnValue({}),
    getSiteColors: returnValue({}),
    getStyleParams: returnValue({}),
    setFontParam: returnValue({}),
    setColorParam: returnValue({}),
    setBooleanParam: returnValue({}),
    setNumberParam: returnValue({}),
    setUILIBParamValue: returnValue({})
  },
  Theme: {
    BARE: 0
  },
  Metadata: {
    setAppMetadata: _lodash.noop,
    removeAppMetadata: _lodash.noop
  }
};

var getWixSdk = function getWixSdk() {
  if (typeof window !== 'undefined') {
    return window.ModuleRegistry ? WixPolyfill : (0, _lodash.get)(window, 'Wix', WixPolyfill); // Workaround for BM Wix SDK
  }

  return WixPolyfill;
};

var Wix = getWixSdk();
var _default = Wix;
exports["default"] = _default;